/**
 *
 * @param start Date
 * @param end Date
 * @returns Array filled with dates between both limits
 */
export const getDateList = (start: Date, end: Date) => {
  const arr = [];

  for (let dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
    arr.push(new Date(dt));
  }

  return arr;
};
